import { render, staticRenderFns } from "./Changepass.vue?vue&type=template&id=2c495416&scoped=true"
import script from "./Changepass.vue?vue&type=script&lang=js"
export * from "./Changepass.vue?vue&type=script&lang=js"
import style0 from "./Changepass.vue?vue&type=style&index=0&id=2c495416&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c495416",
  null
  
)

export default component.exports